module.exports = __webpack_public_path__ + "img/privat24.bcdcae0a.png";